export enum ReceiptRequestErrorCode {
  RECEIPT_ALREADY_REQUESTED = "RECEIPT_ALREADY_REQUESTED",
  RECEIPT_LOCK_RACE = "RECEIPT_LOCK_RACE",
}
